import { Component, Input } from '@angular/core';
import { marked } from 'marked';
import { ChatErrorResponse } from '../../../models/chat-response.model';

@Component({
  selector: 'lib-chat-error-response-message',
  templateUrl: './chat-error-response-message.component.html',
  styleUrls: ['./chat-error-response-message.component.scss'],
  standalone: false
})
export class ChatErrorResponseMessageComponent {
  @Input() response!: ChatErrorResponse;

  renderMarkdown(text: string): string {
    return marked.parse(text, {
      async: false,
      breaks: true,
      gfm: true
    });
  }
}
